import React, { useContext, Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import loadable from '@loadable/component';
import classNames from 'classnames';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import FullScreenLoader from '../FullScreenLoader';
import './styles.css';

const Search = loadable(() => import('./Search'), {
  fallback: <FullScreenLoader />,
});

const SearchAutoSuggest = () => {
  const modalName = MODALS.SEARCH_AUTOSUGGEST;
  const {
    modal: { modals, hideModal },
    media: { mobile },
  } = useContext(Context);
  const [show, setShow] = useState(false);

  const modal = modals[MODALS.SEARCH_AUTOSUGGEST];

  useEffect(() => {
    if (modal.show) {
      setShow(modal.show);
    }
  }, [modal.show]);

  const hide = () => {
    setShow(false);
    setTimeout(() => {
      hideModal(MODALS.SEARCH_AUTOSUGGEST);
    }, 300 - 20);
  };

  if (!modal.show) return null;

  return createPortal(
    <Fragment>
      <div
        style={{
          animation: `${
            show ? 'SearchAutoSuggestFadeIn' : 'SearchAutoSuggestFadeOut'
          } 300ms`,
        }}
        onClick={hide}
        className="SearchAutoSuggest__blackout"
      />
      <div
        style={{
          animation: `${
            show ? 'SearchAutoSuggestModalUp' : 'SearchAutoSuggestModalDown'
          } 300ms`,
        }}
        className={classNames('SearchAutoSuggest__root', {
          'SearchAutoSuggest__root--mobile': mobile,
        })}
      >
        <div className="SearchAutoSuggest__content">
          <div className="SearchAutoSuggest__top">
            <button onClick={hide}>
              <i className="icon-generalxlarge" />
            </button>
          </div>
          <Search modalName={modalName} />
        </div>
      </div>
    </Fragment>,
    document.body
  );
};

export default SearchAutoSuggest;
